<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  created () {
    // prevent localStorage.setItem exception on private browsering
    // https://stackoverflow.com/questions/40873498/error-the-quota-has-been-exceeded-on-safari-ios-10
    try {
      let k = '__testLocalStorage'
      localStorage.setItem(k, k)
      localStorage.removeItem(k)
    } catch (e) {
      localStorage.getItem = () => {}
      localStorage.setItem = () => {}
      localStorage.removeItem = () => {}
      localStorage.clear = () => {}
    }
  }
}
</script>

<style src="./reset.css">
</style>
<style lang="postcss">
@import "index.css";
/* @see https://cn.vuejs.org/css/page.css */
#app {
  /* font-family: "Source Sans Pro", "Helvetica Neue", Arial, sans-serif; */

  /* alike nutsbp.com */
  font-family: "PingFang SC", "Helvetica Neue For Number", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue, Helvetica", Arial, sans-serif;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--colorBlack1);
  background-color: var(--colorWhite);

  @media (--mediaPc) {
    font-size: var(--textSize4);
  }
  @media (--mediaMobile) {
    font-size: var(--textSize4Mobile);
  }
  & a {
    color: var(--colorBlack1);
  }
  & *:disabled {
    cursor: not-allowed;
  }
  /* custom animation */
  & .custom-fade-enter-active,
  & .custom-fade-leave-active {
    transition: opacity .5s;
  }
  & .custom-fade-enter,
  & .custom-fade-leave-to {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue